import type { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

type TProps = {
    filterStatus: "all" | "notseen" | "seen";
    filterType: "document" | "account" | "other" | "";
    setFilterStatus: Dispatch<SetStateAction<"all" | "notseen" | "seen">>;
    setFilterType: Dispatch<SetStateAction<"document" | "account" | "other" | "">>;
};

const NotificationNavbar = ({ filterStatus, filterType, setFilterStatus, setFilterType }: TProps) => {
    const [t] = useTranslation();

    return (
        <div className="notification-navbar">
            <h3>{t("NavigationBar.Notifications")}</h3>
            <div className="container-filter">
                <span>{t("Notifications.NavBar.ByStatus")}</span>
                <ul>
                    <li
                        className={`${filterStatus === "all" ? "selected" : ""}`}
                        onClick={() => setFilterStatus("all")}
                    >
                        {t("Notifications.NavBar.All")}
                    </li>
                    <li
                        className={`${filterStatus === "notseen" ? "selected" : ""}`}
                        onClick={() => setFilterStatus("notseen")}
                    >
                        {t("Notifications.NavBar.ToProcess")}
                    </li>
                    <li
                        className={`${filterStatus === "seen" ? "selected" : ""}`}
                        onClick={() => setFilterStatus("seen")}
                    >
                        {t("Notifications.NavBar.AlreadyProcess")}
                    </li>
                </ul>
            </div>
            <div className="container-filter">
                <span>{t("Notifications.NavBar.ByType")}</span>
                <ul>
                    <li className={`${filterType === "" ? "selected" : ""}`} onClick={() => setFilterType("")}>
                        {t("Notifications.NavBar.AllM")}
                    </li>
                    <li
                        className={`${filterType === "document" ? "selected" : ""}`}
                        onClick={() => setFilterType("document")}
                    >
                        {t("Notifications.NavBar.Document")}
                    </li>
                    <li
                        className={`${filterType === "account" ? "selected" : ""}`}
                        onClick={() => setFilterType("account")}
                    >
                        {t("Notifications.NavBar.Account")}
                    </li>
                    <li
                        className={`${filterType === "other" ? "selected" : ""}`}
                        onClick={() => setFilterType("other")}
                    >
                        {t("Notifications.NavBar.Other")}
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default NotificationNavbar;
